import {WarningSignIcon} from '@/components/svg/WarningSignIcon';
import {dateAvecSlashes} from 'ff-common';
import {HStack, Text, VStack} from '@chakra-ui/react';
import {TFunction} from 'i18next';
import {ReactNode} from 'react';
import {Trans} from 'react-i18next';

export const ErreursLignesBlock: React.FC<{
  nbErreurs: number;
  dateDeLivraison: string;
  isMarketplace: boolean;
  children: ReactNode;
  t: TFunction;
}> = ({nbErreurs, dateDeLivraison, isMarketplace, children, t}) => (
  <VStack
    bg='white'
    gap='0'
    alignItems='start'
    borderWidth={{base: '1px', lg: '1px'}}
    borderStyle='solid'
    borderColor='red.warning'
    borderRadius='12px'
    boxShadow='md'
    maxW='100vw'
    overflow='hidden'
    w='100%'
  >
    <HStack
      p='5'
      textColor='red.warning'
    >
      <WarningSignIcon />
      <Text>
        <Trans t={t}>
          {isMarketplace
            ? t('ligne_produit.indisponible.entete_no_date', {
                count: nbErreurs,
              })
            : t('ligne_produit.indisponible.entete', {
                count: nbErreurs,
                dateDeLivraison: dateAvecSlashes(dateDeLivraison),
              })}
        </Trans>
      </Text>
    </HStack>
    {children}
  </VStack>
);
